import { pharmacyClient } from "@/connect";

export const getSupplierProfitability = async (page: number, pageSize: number) => {
  return await pharmacyClient.supplierProfitabilityReport({
    pageNumber: page,
    pageSize: pageSize,
  });
};